module.exports = __webpack_public_path__ + "img/workers.10e0f3af.jpg";